export enum UserClaim {
  CeetronModuleViewer = 'ProjectCeetronViewer',
}
